export default __webpack_public_path__ + "static/media/timerScreenshot-3-portrait.cada50b9.png";